import {Routes} from "@angular/router";

export const ResourceRoutes: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("@/app/domains/resource/catalog/pages/main-products/main-products.page").then(
                (m) => m.MainProductsPage
            ),
    },
    {
        path: "resource-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/resource/catalog/pages/resource-container/resource-container.page").then(
                        (m) => m.ResourceContainerPage
                    ),
            },
            {
                path: "resource-edit",
                loadComponent: () =>
                    import("@/app/domains/resource/catalog/pages/resource-edit/resource-edit.page").then(
                        (m) => m.ResourceEditPage
                    ),
            },
        ]
    },
    {
        path: "resource-edit",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/resource/catalog/pages/resource-edit/resource-edit.page")
                        .then((m) => m.ResourceEditPage),
            },
            {
                path: "inventory-edit",
                loadComponent: () =>
                    import('@/app/domains/erp/inventory/pages/inventory-edit/inventory-edit.page')
                        .then((m) => m.InventoryEditPage),
            },
            {
                path: "material-list-edit",
                loadComponent: () =>
                    import("../pages/material-list-edit/material-list-edit.page")
                        .then((m) => m.MaterialListEditPage),
            },
        ]
    },
    {
        path: "promotion-container",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/marketplace/promotions/pages/promotion-container/promotion-container.page").then(
                        (m) => m.PromotionContainerPage
                    ),
            },
            {
                path: "promotion-edit",
                loadComponent: () =>
                    import("@/app/domains/marketplace/promotions/pages/promotion-edit/promotion-edit.page").then(
                        (m) => m.PromotionEditPage
                    ),
            },
        ],
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
